const textValue = (value) => (typeof value === 'string' ? value : '');

const listValue = (value, fallbackItem) => {
  if (!Array.isArray(value) || value.length === 0) return [fallbackItem];
  return value.map((item) => ({ ...fallbackItem, ...(item && typeof item === 'object' ? item : {}) }));
};

export const emptySeoContent = () => ({
  seo_title: '',
  meta_description: '',
  introduction: '',
  sections: [{ title: '', body: '' }],
  occasions: [{ label: '', description: '' }],
  rental_benefits: [{ title: '', body: '' }],
  rental_process: [{ title: '', body: '' }],
  faqs: [{ question: '', answer: '' }],
  related_category_links: [{ label: '', url: '' }],
  related_product_links: [{ label: '', url: '' }],
  cta: { label: '', url: '', body: '' },
  is_published: false,
  is_indexable: true,
});

export const normalizeSeoContent = (seo = {}) => {
  const source = seo && typeof seo === 'object' ? seo : {};
  const empty = emptySeoContent();
  return {
    seo_title: textValue(source.seo_title),
    meta_description: textValue(source.meta_description),
    introduction: textValue(source.introduction),
    sections: listValue(source.sections, empty.sections[0]).map((item) => ({
      title: textValue(item.title),
      body: textValue(item.body),
    })),
    occasions: listValue(source.occasions, empty.occasions[0]).map((item) => ({
      label: textValue(item.label),
      description: textValue(item.description),
    })),
    rental_benefits: listValue(source.rental_benefits, empty.rental_benefits[0]).map((item) => ({
      title: textValue(item.title),
      body: textValue(item.body),
    })),
    rental_process: listValue(source.rental_process, empty.rental_process[0]).map((item) => ({
      title: textValue(item.title),
      body: textValue(item.body),
    })),
    faqs: listValue(source.faqs, empty.faqs[0]).map((item) => ({
      question: textValue(item.question),
      answer: textValue(item.answer),
    })),
    related_category_links: listValue(source.related_category_links, empty.related_category_links[0]).map((item) => ({
      label: textValue(item.label),
      url: textValue(item.url),
    })),
    related_product_links: listValue(source.related_product_links, empty.related_product_links[0]).map((item) => ({
      label: textValue(item.label),
      url: textValue(item.url),
    })),
    cta: {
      label: textValue(source.cta?.label),
      url: textValue(source.cta?.url),
      body: textValue(source.cta?.body),
    },
    is_published: source.is_published === true || source.is_published === 1 || source.is_published === '1' || source.is_published === 'true',
    is_indexable: source.is_indexable === undefined || source.is_indexable === null || source.is_indexable === ''
      ? true
      : (source.is_indexable === true || source.is_indexable === 1 || source.is_indexable === '1' || source.is_indexable === 'true'),
  };
};

const trimObject = (item) => Object.fromEntries(
  Object.entries(item).map(([key, value]) => [key, typeof value === 'string' ? value.trim() : value])
);

const keepFilledRows = (rows) => rows.map(trimObject).filter((row) => Object.values(row).some(Boolean));

export const buildCategoryPayload = (form) => ({
  name: form.name.trim(),
  slug: form.slug.trim() || undefined,
  sort_order: Number(form.sort_order) || 0,
  parent_id: form.parent_id ? Number(form.parent_id) : null,
  image_url: form.image_url.trim() || null,
  gender_scope: ['male', 'female', 'unisex'].includes(form.gender_scope) ? form.gender_scope : null,
  seo: {
    seo_title: form.seo.seo_title.trim() || null,
    meta_description: form.seo.meta_description.trim() || null,
    introduction: form.seo.introduction.trim() || null,
    sections: keepFilledRows(form.seo.sections),
    occasions: keepFilledRows(form.seo.occasions),
    rental_benefits: keepFilledRows(form.seo.rental_benefits),
    rental_process: keepFilledRows(form.seo.rental_process),
    faqs: keepFilledRows(form.seo.faqs),
    related_category_links: keepFilledRows(form.seo.related_category_links),
    related_product_links: keepFilledRows(form.seo.related_product_links),
    cta: trimObject(form.seo.cta),
    is_published: Boolean(form.seo.is_published),
    is_indexable: Boolean(form.seo.is_indexable),
  },
});
